<template>
  <highcharts ref="chart" :options="options" />
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'PlasticVsGlassBar',
  props: {
    plastic: {
      type: Object,
      default: null
    },
    glass: {
      type: Object,
      default: null
    },
    stacking: {
      type: String,
      default: 'normal'
    },
    impact: {
      type: String,
      default: 'carbon'
    }
  },
  computed: {
    unit: function () {
      if (this.impact === 'water') {
        return this.$t('litre')
      } else {
        return this.$t('g.co2e')
      }
    },
    glassMachineWashing: function () {
      if (this.glass.name) {
        return this.glass.getWashingImpact().intensity[this.impact] * 1000
      } else {
        return 0
      }
    },
    glassDipping: function () {
      if (this.glass.name) {
        return this.glass.getDippingImpact().intensity[this.impact] * 1000
      } else {
        return 0
      }
    },
    glassAutoClaving: function () {
      if (this.glass.name) {
        return (
          this.glass.getAutoclaveChartImpact().intensity[this.impact] * 1000
        )
      } else {
        return 0
      }
    },
    series: function () {
      return [
        {
          name: this.$t('compGraphicsPlasticVsGlassBar.eol'),
          data: [
            this.plastic.getEOLImpact().intensity[this.impact] * 1000,
            this.glass.getEOLImpact().intensity[this.impact] * 1000
          ],
          color: '#3d9000'
        },
        {
          name: this.$t('compGraphicsPlasticVsGlassBar.manual.washing'),
          data: [
            0,
            this.glass.getManualWashingImpact().intensity[this.impact] * 1000
          ],
          color: '#d1007a'
        },
        {
          name: this.$t('compGraphicsPlasticVsGlassBar.autoclaving'),
          data: [
            this.plastic.getDecontaminationImpact().intensity[this.impact] *
              1000,
            this.glassAutoClaving
          ],
          color: '#1e72d1'
        },
        {
          name: this.$t('compGraphicsPlasticVsGlassBar.machine.washing'),
          data: [0, this.glassMachineWashing],
          color: '#9a00d9'
        },
        {
          name: this.$t('compGraphicsPlasticVsGlassBar.dipping'),
          data: [0, this.glassDipping],
          color: '#8d0003'
        },
        {
          name: this.$t('compGraphicsPlasticVsGlassBar.transportation'),
          data: [
            this.plastic.getTransportImpact().intensity[this.impact] * 1000,
            this.glass.getTransportImpact().intensity[this.impact] * 1000
          ],
          color: '#cf640e'
        },
        {
          name: this.$t('compGraphicsPlasticVsGlassBar.manufacturing'),
          data: [
            this.plastic.getManufacturingChartImpact().intensity[this.impact] *
              1000,
            this.glass.getManufacturingImpact().intensity[this.impact] * 1000
          ],
          color: '#8d6500'
        }
      ]
    },
    categories: function () {
      return [
        this.$t('compGraphicsPlasticVsGlassBar.label-1'),
        this.$t('compGraphicsPlasticVsGlassBar.label-2')
      ]
    },
    ytitle: function () {
      if (this.stacking === 'percent') {
        return this.$t('compGraphicsPlasticVsGlassBar.label-3')
      } else {
        return this.unit
      }
    },
    options: function () {
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        series: this.series,
        xAxis: {
          categories: this.categories,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.ytitle
          }
        },
        plotOptions: {
          column: {
            stacking: this.stacking
          },
          series: {
            pointWidth: 250
          }
        },
        tooltip: {
          shared: true,
          pointFormat:
            '{series.name}' +
            ': <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
          valueDecimals: 2,
          valueSuffix: ' ' + this.unit
        }
      }
    }
  }
}
</script>
